import React, { useState, useCallback } from "react";
import Description from "./Description";
import Models from "./Models";
import Review from "./Review";
import { useSelector } from "react-redux";

const ProductTabs = () => {
    const product = useSelector((state) => state.product.productDetailData);
    const productContent = product?.content;
    const [activeTab, setActiveTab] = useState('description');
    const [activeTabData, setActiveTabData] = useState(null);
console.log(productContent,'productContent')
    // UseCallback to memoize the handleTabClick function
    const handleTabClick = useCallback((tab, tabData = null) => {
        setActiveTab(tab);
        setActiveTabData(tabData);
    }, []);

    // Dynamic tab content rendering based on activeTab
    const getTabContent = () => {
        switch (activeTab) {
            case 'description':
                return <Description />;
            case 'models':
                return <Models activeTabData={activeTabData} />;
            case 'reviews':
                return <Review />;
            default:
                return null;
        }
    };

    return (
        <div className='product-tab-container lg:pl-60 lg:pr-60 md:pl-40 md:pr-40'>
            <div className="tab">
                {/* Render the description tab if product has long_description */}
                {product?.long_description && (
                    <button
                        className={`tab ${activeTab === 'description' ? 'active' : ''}`}
                        onClick={() => handleTabClick('description')}
                    >
                        Description
                    </button>
                )}

                {/* Render a button for each content's curriculum array */}
                {productContent?.map((content, index) => {
                    const curriculum = content?.curriculum_array?.[0];
                    if (!curriculum || curriculum?.show_in_detail_page === '0') return null; // Skip if no curriculum data

                    return (
                        <button
                            key={index}
                            className={`tab ${activeTab === 'models' && activeTabData?.id === curriculum?.id ? 'active' : ''}`}
                            onClick={() => handleTabClick('models', curriculum)}
                        >
                            {curriculum?.name}
                        </button>
                    );
                })}

                {/* For more content show button to on stemcity.tech */}
                {productContent?.length > 0 &&
                    <button className="tab"> <a href="https://stemcity.tech" target="_blank" rel="noopener noreferrer">More curriculum</a> </button>}

                {/* Uncomment this to add a Reviews tab */}
                {/*
                    <button
                      className={`tab ${activeTab === 'reviews' ? 'active' : ''}`}
                      onClick={() => handleTabClick('reviews')}
                    >
                      Reviews
                    </button>
                 */}
            </div>

            {/* Render the active tab content */}
            <div className="tab-content">
                {getTabContent()}
            </div>
        </div>
    );
};

export default ProductTabs;
